export default ({ app }, options, errorControl = false) => {
    return app.$fetch(
        {
            ...options
        },
        errorControl
    );
};
